/* eslint-disable */

import React, { useState } from "react";
import ArticleBase from "./article-base.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo.js";
import Currency from "../../../ui-components/currency/currency.tsx";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";
import RaindropSlider from "../../../ui-components/raindrop-slider/raindrop-slider.tsx";
import OrganisationTitle from "../../../ui-components/organisation-title/organisation-title.tsx";
import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import {
  EXAMPLE_ORGANISATION_ALPHA_NAME,
  EXAMPLE_ORGANISATION_ALPHA_URL,
  EXAMPLE_ORGANISATION_BETA_NAME,
  EXAMPLE_ORGANISATION_BETA_URL,
  URL_RAINDROP,
} from "../../../services/constants.js";
import { Size } from "../../../logic/enums.ts";

const ArticleSubtitle = ({ text }) => {
  return <h2 className="text-3xl font-black pt-10">{text}</h2>;
};

const ContentSimplicity = () => {
  const initialValue = 60;
  const [value, setValue] = useState(initialValue);

  const values = [
    {
      organisationId: "sausage_5FE115AC-D833-49CA-94FF-3D0FB98A7FFD",
      value: 100 - value,
      oldValue: 100 - value,
      selected: false,
    },
    {
      organisationId: "sausage_B87510D1-4E07-4062-A73D-F1C32833AA5D",
      value: value,
      oldValue: value,
      selected: true,
    },
  ];

  return (
    <div className="flex flex-col md:flex-row items-center gap-12 w-full max-w-4xl items-center justify-center">
      <div className="flex flex-col w-full max-w-md p-2 items-center gap-4 ">
        <RaindropCircle
          sausageValues={values}
          isSpringyTransition={false}
          isUsingLayout={false}
          size="SMALL"
        />

        <div className="flex flex-col gap-2 w-full">
          <div className="flex flex-row gap-2  items-center ">
            <OrganisationLogo src={EXAMPLE_ORGANISATION_ALPHA_URL} />

            <OrganisationTitle
              title={EXAMPLE_ORGANISATION_ALPHA_NAME}
              isHydrated={true}
            />

            <div className="ml-auto font-bold text-lg text-color-raindrop-primary text-opacity-60">
              <Currency
                currency={"GBP"}
                subunits={1000 * (values[0].value / 100)}
                isStylised={true}
              />
            </div>
          </div>

          <div className="flex flex-row gap-2 items-center  ">
            <OrganisationLogo src={EXAMPLE_ORGANISATION_BETA_URL} />

            <OrganisationTitle
              title={EXAMPLE_ORGANISATION_BETA_NAME}
              isHydrated={true}
            />
            <div className="ml-auto font-bold text-lg text-color-raindrop-primary ">
              <Currency
                currency={"GBP"}
                subunits={1000 * (values[1].value / 100)}
                isStylised={true}
              />
            </div>
          </div>

          <RaindropDivider />

          <div className="flex flex-row gap-2  items-center ">
            <div className="font-bold whitespace-nowrap">Your contribution</div>
            <div className="ml-auto font-bold text-lg w-fit">
              <Currency currency={"GBP"} subunits={1000} isStylised={true} />
            </div>
          </div>
        </div>
        <div className="w-full">
          <RaindropSlider
            min={10}
            max={90}
            value={value}
            onChange={(newValue) => setValue(newValue)}
          />
        </div>
      </div>
    </div>
  );
};

const Article002 = () => {
  return (
    <ArticleBase title={"So, how does Raindrop work?"}>
      <div className="flex flex-col w-full justify-center gap-12 text-left">
        <p>Great question Shnoodle – let's jump on in!</p>
        <p>You see Shnoodle, some humans give money to help other humans.</p>
        <p>Why?</p>
        <p>
          Because life can be tough, but we're all in it together, so we help
          when we can.
        </p>
        <p>It’s a magical time to be alive 💕</p>

        <ArticleSubtitle text={"So what is that pink thing?"} />
        <p>
          To begin to understand the concept lets first understand the{" "}
          <span className="text-color-raindrop-primary font-bold">
            Raindrop Circle
          </span>{" "}
          and how we use it.
        </p>

        <p>
          You can see a Raindrop Circle below. Look, it’s so pretty! Bold and
          pink.
        </p>

        <div className="flex flex-col w-full items-center">
          <RaindropCircle
            size="SMALL"
            sausageValues={[
              {
                value: 20,
                selected: false,
              },
              {
                value: 50,
                selected: false,
              },
              {
                value: 30,
                selected: false,
              },
            ]}
          />
        </div>

        <p>
          Here we are supporting three charities. It doesn’t matter which for
          now. The size of each segment represents the amount you are giving to
          each organisation.
        </p>
        <p className="">But your total contribution does not change 🥳</p>
        <p>This way Shnoodle, you can say:</p>

        <RaindropCard>
          <FlexCol className="pt-8">
            <div className="absolute text-6xl -translate-x-32 -translate-y-20">
              🐰
            </div>

            <p className="italic ">
              I just want to give £20 a month to do good things!
            </p>
          </FlexCol>
        </RaindropCard>
        <p>
          Then, whenever you like, you can change exactly where your money is
          going.
        </p>

        <ArticleSubtitle text={"Ooo!  Pretty, how does it work?"} />

        <p>
          The Raindrop Circle is a bit magical. You can use the slider below to
          watch as you redistribute your money.
        </p>
        <p>Use the slider below to try it out!</p>

        <div className="flex flex-col items-center w-full">
          <ContentSimplicity />
        </div>

        <p>
          Remember, this is a simplified version of the Raindrop Circle. In the
          app, simply tap the organisation you would like to edit to find the
          slider.
        </p>
        <p>... and that's it, Shnoodle!</p>
        <p>See you next time 💕</p>

        <div className="w-full flex flex-col items-center gap-4">
          <RaindropButton
            title="Try out the app"
            to={URL_RAINDROP + "/raindrop"}
            style={ButtonStyle.Primary}
            size={Size.Large}
          />
        </div>
      </div>
    </ArticleBase>
  );
};

export default Article002;
